// CSRF token utility for future use
// Currently not needed for Betfair connection, but included for future endpoints

let csrfToken: string | null = null;
let tokenExpiry: number = 0;

const API_URL = process.env.REACT_APP_API_URL || '';

export async function getCsrfToken(): Promise<string> {
  // Check if we have a valid token
  if (csrfToken && Date.now() < tokenExpiry) {
    return csrfToken;
  }

  try {
    const response = await fetch(`${API_URL}/api/csrf-token`, {
      method: 'GET',
      credentials: 'include',
    });

    if (!response.ok) {
      throw new Error('Failed to fetch CSRF token');
    }

    const data = await response.json();
    const token = data.csrfToken;
    
    if (!token || typeof token !== 'string') {
      throw new Error('Invalid CSRF token received');
    }
    
    csrfToken = token;
    tokenExpiry = Date.now() + 3600000; // 1 hour

    return csrfToken;
  } catch (error) {
    console.error('Error fetching CSRF token:', error);
    throw error;
  }
}

